{
    "filter": {
        "placeholder": {
            "legal_name": "Filtrer par nom de l'organisation",
            "registration_number": "Filtrer par SIRET",
            "uuid": "Filtrer par ID Partenaire",
            "ports": "Filtrer par ports"
        }
    },
    "keys": {
        "registration_number": "SIRET",
        "uuid": "ID Partenaire",
        "ports": "Ports",
        "legal_name": "Nom de l'organisation"
    }
}